<template>
    <span class="notification-dot" :class="[sizeClass, $attrs.class]" aria-hidden="true" data-testid="notification-marble" />
</template>

<script setup lang="ts">
import { computed } from "vue";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
    size: number;
}>();

const sizeClass = computed(() => {
    const sizeMap: Record<number, string> = {
        1: "h-1 w-1",
        2: "h-2 w-2",
        3: "h-3 w-3",
        4: "h-4 w-4",
    };
    return sizeMap[props.size] ?? "h-2 w-2";
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .notification-dot {
        @apply inline-block shrink-0 rounded-full bg-count-badge-bg motion-safe:animate-shadow-pulse;
        --shadow-pulse-color: var(--color-count-badge-bg);
    }
}
</style>
